import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { forwardRef } from 'react';

const AnimatedExpandIcon = ({ isExpanded }, ref) => (
    <ExpandMoreIcon
        ref={ref}
        sx={{
            transition: 'transform 0.3s',
            transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
        }}
    />
);

export default forwardRef(AnimatedExpandIcon);
